import { renderSvelteComponent } from './utils/render.js';
import BlockParty from './components/embeds/BlockParty.svelte';

let page = document.getElementById('embed');

renderSvelteComponent(BlockParty, /** @type {HTMLElement} */ (page), {});
